import { Loading } from '@oppy/omniv2-ui';
import { Suspense } from 'react';
import { useMatches } from 'react-router-dom';

import Logo from './components/logo';
import NavigationItems from './components/navigation-items';
import SubNavigationItems from './components/sub-navigation-items';
import { useNavigationItems } from './main-nav.config';

export default function MainNav() {
  const matches = useMatches();
  const navigationItems = useNavigationItems();
  const parent = navigationItems.find(item =>
    matches.map(match => match.id).includes(item.id),
  );

  return (
    <nav data-testid="main-nav">
      <Logo />
      <Suspense fallback={<Loading />}>
        <NavigationItems navigationItems={navigationItems} />
      </Suspense>

      <Suspense fallback={<Loading />}>
        <SubNavigationItems
          title={parent?.label}
          navigationItems={parent?.subItems}
        />
      </Suspense>
    </nav>
  );
}
